import React from "react";
import { connect } from "react-redux";
import _ from "lodash";

import Select from "Components/common/Select/Select";

@connect(store => {
    return {
        files: store.files
    };
})

class Location extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            options: [
                {value: null, label: "Select"},
                {value: "library", label: "Library"},
                {value: "activities", label: "Activities"}
            ]
        }
    }

    render() {
        const { dispatch, files } = this.props;

        const handleSelect = (value) => {
            dispatch({ type: "UPDATE_FILES_FILTERS", filters: {location: value} });
        }

        return (
            <div class="optionRow">
                <span>Location</span>
                <div class="optionChoices">
                    <Select 
                        classes={{options: "filesFilterOptions"}}
                        options={this.state.options}
                        placeholder="Select"
                        onChange={handleSelect}
                        selected={files.filters.options.location}
                        isClose={files.filters.isCleared}
                    />
                </div>
            </div>
        );
    }
}

export default Location;